export const addGlobalThemeModal = {
  extends: 'ModalWindow',
  tag: 'form',
  state: {
    value: {}
  },
  props: {
    onSubmit: async (e, el, s, ctx) => {
      e.preventDefault()
      const { value, themeModifier } = s
      if (!themeModifier || !value) {
        return
      }
      const modifierName = themeModifier.slice(0, 1) === '@' ? themeModifier : `@${themeModifier}`

      await el.call('closeRouterModal')
      const t = setTimeout(async () => {
        await el.updateDesignSystem({
          theme: {
            document: {
              [modifierName]: value
            }
          }
        })
        clearTimeout(t)
      }, 75)
    }
  },
  ModalHeader: {
    title: 'Add global theme',
    p: 'Adding new <body> styling theme'
  },
  Preview: {
    props: (el, s) => {
      const { color, background } = s.value
      return {
        color: el.call('getColorValue', color),
        background: el.call('getColorValue', background),
        margin: '0 -A2',
        minHeight: 'B2',
        textAlign: 'center',
        round: 'V',
        padding: 'B C'
      }
    },
    H5: (el) => el.getRootState().sampleText
  },
  Flex_fields: {
    padding: 'A C3 0',
    if: (el, s) => s.themeModifier !== '@light' && s.themeModifier !== '@dark',
    InputField: {
      Title: {
        text: '{{ editor.addGlobalTheme.name | polyglot }}'
      },
      Input: {
        placeholder: (el) => el.call('polyglot', 'editor.addGlobalTheme.namePlaceholder'),
        value: '{{ themeModifier }}',
        onKeyup: (e, el, s) => {
          s.update({
            themeModifier: el.node.value
          })
        }
      }
    }
  },
  Flex: {
    gap: 'A',
    padding: '0 C3 C1',
    align: 'center flex-start',
    childExtends: 'ColorSelectWithTitle',
    childProps: {
      width: '100%',
      ColorSelect: {
        props: (el, s) => {
          const { color } = el.getDesignSystem()
          if (!color || !s.value) {
            return null
          }

          const key = s.value[el.parent.key]

          const obj = {
            property: el.parent.key,
            Value: {
              Box: {
                background: key || 'transparentBg',
                backgroundSize: '6px 6px'
              },
              Text: {
                text: key || 'inherit'
              }
            },
            Dropdown: {
              maxHeight: 'G'
            }
          }

          if (!key) {
            return obj
          }

          const value = el.call('getColorValue', key)
          obj.title.box.background = value || key || 'transparentBg'

          return obj
        },
        Dropdown: {
          onChoose: (ev, el, s, ctx, calleeElement) => {
            const { key } = el.parent.parent
            const value = {
              [key]: calleeElement.state.key
            }
            s.update({
              value
            })
          }
        }
      }
    },
    Background: {
      Title: {
        text: '{{ editor.addGlobalTheme.background | polyglot }}'
      },
      ColorSelect: {}
    },
    Color: {
      Title: {
        text: '{{ editor.addGlobalTheme.textColor | polyglot }}'
      },
      ColorSelect: {}
    }
  },
  ModalFooter: {
    CheckButton: {
      type: 'submit',
      text: '{{ common.action.save | polyglot }}'
    }
  }
}
